import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import NumberOfWidesPopupDetails from './NumberOfWidesPopupDetails.vue'

export const NumberOfWidesPopup = new PopupBuilder('Number of Wides')
  .appendBody(NumberOfWidesPopupDetails)
  .build()
